import { UniqueIdentifier } from '@dnd-kit/core';
import { ICanDropOutcome } from './types';

// the gap width is defined as constant because "insertion indicators" are
// spliced within the grid with negative margins equal to the half of it, so they
// don't visually create an extra item in the flex box view, effectively doubling the gap
export const DND_GRID_GAP = 16;
export const GRID_BORDER_WIDTH = 16;
export const INDICATOR_THICKNESS = 2;

export const ENTIRE_GRID_DROPPABLE_ID: UniqueIdentifier =
  '__entire_grid_droppable';

// might be a bit counterintuitive to set the default outcome to "true"
// but when it is "false", if you start dragging, and you haven't hovered any
// droppable yet, the displayed overlay shows the "disabled drop" view and
// it looks strange
export const INITIAL_CAN_DROP_OUTCOME: ICanDropOutcome = {
  canDrop: true,
};
